import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent, DialogConfig } from '@vsolv/vectors-ui/dialog';
import { Distributor } from '@wsphere/distributors/domain';
import { map } from 'rxjs';
import { DistributorService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-deactivate-distributor-dialog',
  templateUrl: './deactivate-distributor.dialog.html',
  standalone: false,
})
export class DeactivateDistributorDialog {
  constructor(
    private toastSvc: ToastService,
    private distributorSvc: DistributorService,
    private breakpointObserver: BreakpointObserver
  ) {}
  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() dialogConfig?: DialogConfig;
  @Input() distributor?: Distributor.Model | null;

  @Output() closed = new EventEmitter<string>();

  saving = false;

  isMobile$ = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(map(state => state.matches));

  openDialog() {
    this.dialog.open();
  }

  closeDialog() {
    this.dialog.close();
  }

  cancel() {
    this.closeDialog();
  }

  async deactivateDistributor() {
    this.saving = true;

    if (!this.distributor) throw new Error('Unable to deactivate distributor, distributor not found');

    const deactivatedDistributor = await this.distributorSvc
      .deactivateDistributor(this.distributor.id)
      .catch(({ error }) => {
        this.toastSvc.show({
          type: 'error',
          title: 'Something went wrong',
          text: error.message,
        });

        this.closeDialog();
        this.saving = false;
      });

    const deactivatedDistributorId =
      deactivatedDistributor && typeof deactivatedDistributor === 'object' && 'id' in deactivatedDistributor
        ? deactivatedDistributor.id
        : undefined;
    if (deactivatedDistributorId) {
      this.toastSvc.show({
        type: 'success',
        title: 'Distributor deactivated',
        text:
          '<strong>' +
          this.distributor?.name +
          '</strong> has been successfully deactivated. Members can now access SFTP as read-only.',
      });

      this.closeDialog();
      this.closed.emit(deactivatedDistributorId);
      this.saving = false;
    }
  }
}
